import React, { useState } from "react";
import classes from "./NotificationsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { useHistory } from "react-router-dom";
import {
  Arrowlinkicon,
  cancelIcon,
  Notify,
} from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { Switch } from "../../../../../stories/Switch/Switch";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";

const NotificationsMobile = () => {
  const history = useHistory();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const dispatch = useDispatch();
  // setActiveTab
  const [notificationarray, setNotificationarray] = useState(_noti);

  // UpdateNotificationsValues
  const handleUpdateNotificationsValues = (item, i, type = "email") => {
    const notificationarrayCopy = [...notificationarray];
    if (type == "email") notificationarrayCopy[i].email = !item?.email;
    if (type == "dAm")
      notificationarrayCopy[i].desktopAndMobile = !item?.desktopAndMobile;

    setNotificationarray(notificationarrayCopy);
  };
  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;
  return (
    <div className={[classes.NotificationsScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Profile Settings
        </p>
      </div>
      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0"].join(" ")}>
          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Tabs
              tabsData={[
                { label: "Privacy settings", activeText: "privacy-settings" },
                { label: "Payout methods", activeText: "payout-methods" },
                { label: "Notifications", activeText: "notifications" },
              ]}
              state={{ label: convertedActiveTab }}
              setState={(item) => dispatch(setActiveTab(item?.activeText))}
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <div className={[classes.notifydiv].join(" ")}>
              <div
                className={[classes.notifycontentcenter, classes.mb24].join(
                  " "
                )}
              >
                <img
                  src={Notify}
                  className={[classes.notifyimg].join(" ")}
                  alt="..."
                />
              </div>
              <div className={[classes.mb24].join(" ")}>
                <h6
                  style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
                  className={[classes.mb8, classes.textcenter].join(" ")}
                >
                  You need to allow permission for notifications
                </h6>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                    fontSzie: "14px",
                    lineHeight: "20px",
                  }}
                  className={[classes.textcenter].join(" ")}
                >
                  You need to allow permission for notifications
                </p>
              </div>
              <Button
                primary={false}
                customStyle={{ ...Fonts.b2, width: "100%" }}
                size="Large"
              >
                Allow notiifications
              </Button>
            </div>
          </Col>

          <Col sm={12}>
            <h5
              style={{
                ...Fonts.h5,
                color: Colors.neutralShadesOfNero,
                fontSize: "19px",
                lineHeight: "24px",
              }}
              className={[classes.pb24].join(" ")}
            >
              Notify me when:
            </h5>
          </Col>

          {notificationarray.map((item, i) => {
            return (
              <Col
                sm={12}
                className={[classes.mb24].join(" ")}
                key={i}
                style={{
                  borderBottom:
                    i !== notificationarray.length - 1 && "1px solid #dddddd",
                  paddingBottom: i !== notificationarray.length - 1 && "8px",
                }}
              >
                <p
                  className={[classes.mb16].join(" ")}
                  style={{
                    ...Fonts.h7,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  {item?.title}
                </p>
                <div
                  className={[
                    classes.dflex,
                    classes.contentbetween,
                    classes.mb16,
                  ].join(" ")}
                >
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    Email
                  </p>
                  <Switch
                    value={item?.email}
                    setter={() => handleUpdateNotificationsValues(item, i)}
                  />
                </div>
                <div
                  className={[
                    classes.dflex,
                    classes.contentbetween,
                    classes.mb16,
                  ].join(" ")}
                >
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    Desktop and mobile
                  </p>
                  <Switch
                    value={item?.desktopAndMobile}
                    setter={() =>
                      handleUpdateNotificationsValues(item, i, "dAm")
                    }
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};
export default NotificationsMobile;

const _noti = [
  {
    title: "Someone message me",
    email: false,
    desktopAndMobile: false,
  },
  {
    title: "Anyone left me a review",
    email: false,
    desktopAndMobile: false,
  },
  {
    title: "Anyone cancelled the lesson",
    email: false,
    desktopAndMobile: false,
  },
  {
    title: "Anyone accept or decline the lesson",
    email: false,
    desktopAndMobile: false,
  },
  {
    title: "Get Lytesnap news, announcements, and product updates",
    email: false,
    desktopAndMobile: false,
  },
];
